import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { Home, Search, ArrowLeft, Coffee } from 'lucide-react'
import { useLanguage } from '../context/LanguageContext'

const NotFound = () => {
  const { t } = useLanguage()

  return (
    <div className="min-h-screen bg-dark flex items-center justify-center px-4 py-20">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-2xl w-full text-center"
      >
        {/* 404 Number */}
        <motion.div
          initial={{ scale: 0.5 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', duration: 0.8 }}
          className="relative mb-8"
        >
          <h1 className="text-[150px] sm:text-[200px] font-display font-bold text-gradient-gold leading-none">
            404
          </h1>
          <motion.div
            animate={{ rotate: [0, 10, -10, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          >
            <Coffee className="w-16 h-16 text-gold-400 opacity-20" />
          </motion.div>
        </motion.div>

        {/* Message */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="mb-8"
        >
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-cream mb-4">
            Ups! Faqja Nuk U Gjet
          </h2>
          <p className="text-beige-300 text-lg mb-2">
            Faqja që po kërkoni mund të jetë zhvendosur, fshirë, ose mbase nuk ka ekzistuar kurrë.
          </p>
          <p className="text-beige-400">
            Por mos u shqetëso - ka shumë gjëra të tjera për të parë! 🚀
          </p>
        </motion.div>

        {/* Actions */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-gradient-gold text-white font-bold rounded-xl shadow-lg hover:shadow-gold-400/50 transition-all"
          >
            <Home className="w-5 h-5" />
            Kthehu në Home
          </Link>

          <Link
            to="/services"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-bronze-900 border-2 border-gold-400/30 text-cream font-semibold rounded-xl hover:border-gold-400 transition-all"
          >
            <Search className="w-5 h-5" />
            Shiko Shërbimet
          </Link>
        </motion.div>

        {/* Suggestions */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
          className="mt-12 p-6 bg-bronze-900/50 border border-gold-400/20 rounded-2xl"
        >
          <h3 className="text-xl font-display font-bold text-cream mb-4">
            Mund të të interesojnë:
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            <Link
              to="/portfolio"
              className="p-3 bg-bronze-800 hover:bg-bronze-700 rounded-lg text-beige-300 hover:text-gold-400 transition-all text-sm"
            >
              Portfolio
            </Link>
            <Link
              to="/blog"
              className="p-3 bg-bronze-800 hover:bg-bronze-700 rounded-lg text-beige-300 hover:text-gold-400 transition-all text-sm"
            >
              Blog
            </Link>
            <Link
              to="/contact"
              className="p-3 bg-bronze-800 hover:bg-bronze-700 rounded-lg text-beige-300 hover:text-gold-400 transition-all text-sm"
            >
              Kontakt
            </Link>
            <Link
              to="/about"
              className="p-3 bg-bronze-800 hover:bg-bronze-700 rounded-lg text-beige-300 hover:text-gold-400 transition-all text-sm"
            >
              Rreth Nesh
            </Link>
          </div>
        </motion.div>

        {/* Back Button */}
        <motion.button
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9 }}
          onClick={() => window.history.back()}
          className="mt-8 inline-flex items-center gap-2 text-beige-400 hover:text-gold-400 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Kthehu Mbrapa
        </motion.button>
      </motion.div>
    </div>
  )
}

export default NotFound
